import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Menu,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  fetchCreateNewProduct,
  fetchEditProduct,
  fetchGetGrupe,
  fetchGetGrupeClear,
  fetchGetKategorije,
  fetchGetNadgrupe,
  fetchGetNadgrupeClear,
  fetchProductDetaiList,
  fetchProductPagesList,
  fetchUpdateProductItem,
} from "../actions/product";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import CheckIcon from "@mui/icons-material/Check";
import { Fragment } from "react";
import InputField from "../components/Admin/Reusable/InputField";
import { basicFormValidationHandler, formatDate } from "../utils";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useCallback } from "react";
import { useState } from "react";
import { fetchCategoriesListItems } from "../actions/categories";

const Product = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    dataPagesDetail,
    dataCategoryKategorije,
    dataCategoryNadgrupe,
    dataCategoryGrupe,
  } = useSelector((state) => state.productReducer);

  const { dataPagesList } = useSelector((state) => state.categoriesReducer);

  useEffect(() => {
    dispatch(fetchCategoriesListItems());
  }, [dispatch]);

  const resetState = useCallback(() => {
    return {
      b2bPrice: "",
      barcode: "",
      price: "",
      cashPrice: "",
      fixPrice: "",
      updatedAt: "",
      createdAt: "",
      deklaracija: "",
      energetska_klasa: "",
      energetska_klasa_link: "",
      energetska_klasa_pdf: "",
      flag_akcija_cena: "",
      grupa: "",
      id: "",
      izmenio: "",
      jedinica_mere: "",
      quantity: "",
      model: "",
      mpPrice: "",
      nadgrupa: "",
      name: "",
      opis: "",
      pdv: "",
      brand: "",
      code: "",
      slika: "",
      uneo: "",
      valuta: "",
      web_cena: "",
      active: "",
      sale: "",
      highlighted: "",
      trending: "",
      bestSeller: "",
      recommended: "",
      monthlySale: "",
      cena_bez_pdv: "",
      categoryId: "",
      nadgrupa_id: "",
      grupa_id: "",
    };
  }, []);

  const initialState = {
    b2bPrice: "",
    barcode: "",
    price: "",
    cashPrice: "",
    fixPrice: "",
    updatedAt: "",
    createdAt: "",
    deklaracija: "",
    energetska_klasa: "",
    energetska_klasa_link: "",
    energetska_klasa_pdf: "",
    flag_akcija_cena: "",
    grupa: "",
    id: "",
    izmenio: "",
    jedinica_mere: "",
    quantity: "",
    model: "",
    mpPrice: "",
    nadgrupa: "",
    name: "",
    opis: "",
    pdv: "",
    brand: "",
    code: "",
    slika: "",
    uneo: "",
    valuta: "",
    web_cena: "",
    active: "",
    sale: "",
    highlighted: "",
    trending: "",
    bestSeller: "",
    recommended: "",
    monthlySale: "",
    cena_bez_pdv: "",
    categoryId: "",
    nadgrupa_id: "",
    grupa_id: "",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      //pozvati detalje proizvoda
      dispatch(fetchProductDetaiList(id));
    } else {
      setData(resetState());
    }
  }, [id, dispatch, resetState]);

  // useEffect(() => {
  //   //potrebno je pozvati kategorije, nagrupe i grupe kao tri niza
  //   if (data.categoryId > 0) {
  //     dispatch(fetchGetNadgrupe(data.categoryId)); //nadgrupa
  //   } else {
  //     dispatch(fetchGetNadgrupeClear());
  //   }

  //   if (data.nadgrupa_id > 0) {
  //     dispatch(fetchGetGrupe(data.nadgrupa_id)); //grupa
  //   } else {
  //     dispatch(fetchGetGrupeClear());
  //   }
  // }, [data.categoryId, data.nadgrupa_id, dispatch]);

  useEffect(() => {
    if (dataPagesDetail && Object.keys(dataPagesDetail).length > 0) {
      setData(dataPagesDetail);
    }
  }, [dataPagesDetail]);

  const productValidationHandler = () => {
    const { fixPrice } = data;

    let errorsObject = {};
    errorsObject = basicFormValidationHandler({
      fixPrice,
    });

    setErrors(errorsObject);
    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event.target;

    // Ako je checkbox, koristi boolean, u suprotnom value
    const inputValue = type === "checkbox" ? checked : value;

    if (name === "categoryId") {
      setData((prevUser) => ({
        ...prevUser,
        nadgrupa_id: 0,
        grupa_id: 0,
      }));
    } else if (name === "nadgrupa_id") {
      setData((prevUser) => ({
        ...prevUser,
        grupa_id: 0,
      }));
    }

    setData((prevUser) => ({
      ...prevUser,
      [name]: inputValue,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    //definisanje vrednosti za slanje za izmenu
    const dataForm = {
      categoryId: data?.categoryId,
      fixPrice: data?.fixPrice,
      sale: data?.sale,
      highlighted: data?.highlighted,
      monthlySale: data?.monthlySale,
      trending: data?.trending,
      recommended: data?.recommended,
      bestSeller: data?.bestSeller,
      hidden: data?.hidden,
    };

    dispatch(fetchUpdateProductItem(data?.id, dataForm));

    // Postavljanje podrazumevanih vrednosti ako su NULL
    // const status = data.status !== null ? data.status : 1; // Postaviti status na 1 ako je null
    // const sale = data.sale !== null ? data.sale : 0; // Postaviti akciju na 0 ako je null
    // const highlighted = data.highlighted !== null ? data.highlighted : 0; // Postaviti highlighted na 0 ako je null
    // const trending = data.trending !== null ? data.trending : 0; // Postaviti trending na 0 ako je null
    // const bestSeller =
    //   data.bestSeller !== null ? data.bestSeller : 0; // Postaviti trending na 0 ako je null
    // const recommended = data.recommended !== null ? data.recommended : 0; // Postaviti trending na 0 ako je null
    // const cenaFinal = data.fixPrice !== null ? data.fixPrice : ""; // Postaviti trending na 0 ako je null
    // const monthlySale =
    //   data.monthlySale !== null ? data.monthlySale : 0; // Postaviti nedeljnu akciju na 0 ako je null

    // // Kreiranje FormData objekta sa svim potrebnim podacima
    // const formData = new FormData();
    // formData.append("price", cenaFinal);
    // formData.append("code", data.code);
    // formData.append("grupa", data.grupa);
    // formData.append("status", status);
    // formData.append("sale", sale);
    // formData.append("trending", trending);
    // formData.append("monthlySale", monthlySale);
    // formData.append("highlighted", highlighted);
    // formData.append("bestSeller", bestSeller);
    // formData.append("recommended", recommended);
    // formData.append("categoryId", data.categoryId);
    // formData.append("nadgrupa_id", data.nadgrupa_id);
    // formData.append("grupa_id", data.grupa_id);

    // // Prosleđivanje formData objekta zahtevu za kreiranje ili izmenu proizvoda
    // if (id) {
    //   dispatch(fetchEditProduct(formData, id));
    // } else {
    //   dispatch(fetchCreateNewProduct(formData));
    // }
  };

  console.log(dataPagesDetail, "dataPagesDetail");

  return (
    <Fragment>
      <Breadcrumb
        title={`${data?.code} - ${data?.name}`}
        type="product-forma"
      />
      <div className="row">
        <div className="col-12">
          <form onSubmit={handleSubmit} noValidate>
            <div className="row">
              <div className="col">
                <div className="float-end mb-3">
                  {id ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      startIcon={<CheckIcon />}
                    >
                      Potvrda izmene
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      startIcon={<AddIcon />}
                    >
                      Kreiraj
                    </Button>
                  )}
                </div>
              </div>
              <div className="product-admin-holder-item">
                <div className="product-holder-admin-left-side">
                  <div className="card">
                    <div className="card-body">
                      <div className="holder-left-side-main">
                        <div className="product-holder-admin-left-side-image">
                          <img src={data?.images?.[0]} className="img-fluid" />
                        </div>
                        <div className="product-holder-admin-left-side-text">
                          <h6 class="fs-15 mb-3">Osnovni podaci</h6>
                          <div className="row">
                            <div className="col-12">
                              <InputField
                                label="code"
                                name="code"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data?.code}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputLabelProps={{ shrink: true }}
                                inputProps={{
                                  readOnly: true,
                                }}
                              />
                            </div>
                            <div className="col-12">
                              <InputField
                                label="barcode"
                                name="barcode"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data?.barcode}
                                onChange={handleInputChange}
                                fullWidth
                                inputProps={{
                                  readOnly: true,
                                }}
                                size="small"
                                className="mb-4"
                                inputLabelProps={{ shrink: true }}
                              />
                            </div>
                            <div className="col-12">
                              <InputField
                                label="Naziv proizvoda"
                                name="name"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data?.name}
                                onChange={handleInputChange}
                                fullWidth
                                multiline
                                size="small"
                                className="mb-4"
                                inputLabelProps={{ shrink: true }}
                                inputProps={{
                                  readOnly: true,
                                }}
                              />
                            </div>
                            <div className="col-12">
                              <InputField
                                label="Brend"
                                name="brand"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data?.brand}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputLabelProps={{ shrink: true }}
                                inputProps={{
                                  readOnly: true,
                                }}
                              />
                            </div>
                            {/* <div className="col-12">
                              <InputField
                                label="Kategorija"
                                name="categoryName"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data?.categoryName}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                inputLabelProps={{ shrink: true }}
                                inputProps={{
                                  readOnly: true,
                                }}
                              />
                            </div> */}
                            <div className="col-12">
                              {/* dataCategoryKategorije */}
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Kategorija
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={data.categoryId}
                                  label="Kategorija"
                                  name="categoryId"
                                  onChange={handleInputChange}
                                  size="small"
                                  className="mb-4"
                                >
                                  {dataPagesList?.map((item) => (
                                    <MenuItem value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              {/* <InputField
                                label="Kategorija"
                                name="categoryId"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.categoryId}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                              /> */}
                            </div>
                            <div className="col-12">
                              {/* <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Nadgrupa
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={data.nadgrupa_id}
                                  name="nadgrupa_id"
                                  label="Nadgrupe"
                                  onChange={handleInputChange}
                                  size="small"
                                  className="mb-4"
                                >
                                  {dataCategoryNadgrupe?.map((item) => (
                                    <MenuItem value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl> */}
                              {/* <InputField
                                label="nadgrupa"
                                name="nadgrupa_id"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.nadgrupa_id}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                              /> */}
                            </div>
                            <div className="col-12">
                              {/* <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  Grupa
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  value={data.grupa_id}
                                  name="grupa_id"
                                  label="Grupa"
                                  onChange={handleInputChange}
                                  size="small"
                                  className="mb-4"
                                >
                                  {dataCategoryGrupe?.map((item) => (
                                    <MenuItem value={item.id}>
                                      {item.name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl> */}
                              {/* <InputField
                                label="grupa"
                                name="grupa_id"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.grupa_id}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                              /> */}
                            </div>
                            {/* <div className="col-12">
                              <InputField
                                label="model"
                                name="model"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.model}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="product-holder-admin-right-side">
                  <div className="card">
                    <div className="card-header">Stanje proizvoda</div>
                    <div className="card-body">
                      <div className="row">
                        {/* <div className="col-xl-4 col-lg-4 col-md-6">
                          <InputField
                            label="Cena bez pdv"
                            name="cena_bez_pdv"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data.cena_bez_pdv}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            disabled
                            inputProps={{
                              readOnly: true,
                            }}
                          />
                        </div> */}
                        <div className="col-xl-3 col-lg-3 col-md-6">
                          <InputField
                            label="Cena sa pdv"
                            name="price"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.price}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            inputLabelProps={{ shrink: true }}
                          />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6">
                          <InputField
                            label="WEB Cena"
                            name="cashPrice"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.cashPrice}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            inputLabelProps={{ shrink: true }}
                          />
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-6">
                          <InputField
                            label="Nova Cena"
                            name="fixPrice"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.fixPrice}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                          />
                        </div>
                        <div className="col-xl-3 col-lg-2 col-md-6">
                          <InputField
                            label="Količina"
                            name="quantity"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.quantity}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            inputLabelProps={{ shrink: true }}
                          />
                        </div>
                        {/* <div className="col-xl-2 col-lg-2 col-md-6">
                          <InputField
                            label="Jedinica mere"
                            name="jedinica_mere"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data.jedinica_mere}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            disabled
                          />
                        </div> */}
                        {/* <div className="col-xl-4 col-lg-4 col-md-6">
                          <InputField
                            label="pdv"
                            name="pdv"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data.pdv}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            disabled
                          /> */}
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">USPON Cene</div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xl-3 col-lg-4 col-md-6">
                          <InputField
                            label="B2B Cena"
                            name="b2bPrice"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.b2bPrice}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            inputLabelProps={{ shrink: true }}
                          />
                        </div>
                        {/* <div className="col-xl-4 col-lg-4 col-md-6">
                        <InputField
                          label="Web Cena"
                          name="web_cena"
                          error={errors}
                          errorsHandler={setErrors}
                          value={data.web_cena}
                          onChange={handleInputChange}
                          fullWidth
                          size="small"
                          className="mb-4"
                          inputProps={{
                            readOnly: true,
                          }}
                          disabled
                        />
                      </div> */}
                        <div className="col-xl-3 col-lg-4 col-md-6">
                          <InputField
                            label="MP Cena"
                            name="mpPrice"
                            error={errors}
                            errorsHandler={setErrors}
                            value={data?.mpPrice}
                            onChange={handleInputChange}
                            fullWidth
                            size="small"
                            className="mb-4"
                            inputProps={{
                              readOnly: true,
                            }}
                            inputLabelProps={{ shrink: true }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">Dodatna podešavanja</div>
                    <div className="card-body">
                      <div className="row">
                        <div className="row">
                          <div className="col-lg-4 col-sm-12">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="active"
                                  checked={!data?.hidden}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      hidden: !e.target.checked,
                                    })
                                  }
                                  size="small"
                                />
                              }
                              label="Aktivan proizvod"
                            />

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.sale}
                                    onChange={handleInputChange}
                                    name="sale"
                                  />
                                }
                                label="Akcija"
                              />
                            </FormGroup>

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.highlighted}
                                    onChange={handleInputChange}
                                    name="highlighted"
                                  />
                                }
                                label="Izdvojeno"
                              />
                            </FormGroup>

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.monthlySale}
                                    onChange={handleInputChange}
                                    name="monthlySale"
                                  />
                                }
                                label="Mesečna sale"
                              />
                            </FormGroup>

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.trending}
                                    onChange={handleInputChange}
                                    name="trending"
                                  />
                                }
                                label="Popularno"
                              />
                            </FormGroup>

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.bestSeller}
                                    onChange={handleInputChange}
                                    name="bestSeller"
                                  />
                                }
                                label="Najprodavanije"
                              />
                            </FormGroup>

                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={data?.recommended}
                                    onChange={handleInputChange}
                                    name="recommended"
                                  />
                                }
                                label="Preporučujemo"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-lg-8 col-sm-12">
                            <h6 class="fs-15 mb-3">Ostale informacije</h6>
                            <div className="row">
                              {/* <div className="col-xl-6 col-lg-6 col-md-6">
                              <InputField
                                label="energetska_klasa"
                                name="energetska_klasa"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.energetska_klasa}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6">
                              <InputField
                                label="energetska_klasa_link"
                                name="energetska_klasa_link"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.energetska_klasa_link}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6">
                              <InputField
                                label="energetska_klasa_pdf"
                                name="energetska_klasa_pdf"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.energetska_klasa_pdf}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            </div> */}
                              {/* <div className="col-xl-6 col-lg-6 col-md-6">
                              <InputField
                                label="flag_akcija_cena"
                                name="flag_akcija_cena"
                                error={errors}
                                errorsHandler={setErrors}
                                value={data.flag_akcija_cena}
                                onChange={handleInputChange}
                                fullWidth
                                size="small"
                                className="mb-4"
                                inputProps={{
                                  readOnly: true,
                                }}
                                disabled
                              />
                            </div> */}
                              <div className="col-xl-6 col-lg-6 col-md-6">
                                <InputField
                                  label="Datum promene"
                                  name="updatedAt"
                                  error={errors}
                                  errorsHandler={setErrors}
                                  value={formatDate(data?.updatedAt)}
                                  onChange={handleInputChange}
                                  fullWidth
                                  size="small"
                                  className="mb-4"
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                  inputLabelProps={{ shrink: true }}
                                />
                              </div>
                              <div className="col-xl-6 col-lg-6 col-md-6">
                                <InputField
                                  label="Datum kreiranja"
                                  name="createdAt"
                                  error={errors}
                                  errorsHandler={setErrors}
                                  value={formatDate(data?.createdAt)}
                                  onChange={handleInputChange}
                                  fullWidth
                                  size="small"
                                  className="mb-4"
                                  inputProps={{
                                    readOnly: true,
                                  }}
                                  inputLabelProps={{ shrink: true }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header">Opis</div>
                    <div className="card-body">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.description?.replace(/<br\s*\/?>/g, ""),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default Product;
